import { AfterViewChecked, AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

import * as _ from "lodash";

@Component({
  selector: 'app-quickrange',
  templateUrl: './quickrange.component.html',
  styleUrls: ['./quickrange.component.css']
})
export class QuickrangeComponent implements OnInit {

  filterArr: any[] = [{ "name": "TYD", "flag": true, "disableFlag": false }, { "name": "1W", "flag": false, "disableFlag": false }, { "name": "1M", "flag": false, "disableFlag": false }, { "name": "3M", "flag": false, "disableFlag": false }, { "name": "FY", "flag": false, "disableFlag": false }];

  @Output() onFilterChange = new EventEmitter<{}>();
  @Input() resetAll = true;

  //@Input() filter:any[]=[{"name":"3M"},{"name":"FY"}];
  @Input() disableFilter: boolean = false;
  @Input() disableArr = [];
  filterSelection = _.filter(this.filterArr, eachObj => eachObj.flag == true)[0]['name'];
  filterLevel = _.filter(this.filterArr, eachObj => eachObj.flag == true); 
  @Input() msgFromFilter: boolean;
  @Input() selectedFilterValue: string;
  constructor() { 
     //  console.log("check flag")
  }

  ngOnChanges() {  
    //When we select custom date range remaining filter should be unselected
    if(!this.msgFromFilter){
      this.filterArr = _.map(this.filterArr, eachObj => { eachObj.flag = false
          return eachObj
        });
    }
    //Disable and Enable the filter based on configuration
   // if(this.disableFilter || this.disableArr.length>0) { //alert timefilter will work but dont use disable filter will not work
   if(this.disableFilter) {
    

   } else 
   if(this.disableArr.length > 0 ) {  // > 1 if we use && alerts page will get work
    if(this.disableArr.indexOf("ALL") != -1)
          this.filterArr.map(filterObj=>filterObj['disableFlag'] = true);
      else {
          let defaultSelectionFlag = true;
          this.filterArr.map(filterObj=> {
            filterObj['disableFlag'] = (this.disableArr.indexOf(filterObj['name'])!=-1) ? true : false;
            filterObj['flag'] = false;
            if(defaultSelectionFlag && this.disableArr.indexOf(filterObj['name'])==-1 && this.msgFromFilter) {
              filterObj['flag'] = true;
              defaultSelectionFlag = false;
            } 
            return filterObj;
          });

          let sampleFilter = this.filterArr
           sampleFilter = sampleFilter.map((element)=>{
           if(this.selectedFilterValue===element['name']){
          element['flag'] = true;
           }else{
            element['flag'] = false;
           }
        })
        }
       
    } else if(this.disableFilter && this.disableArr.length>0){
      if(this.disableArr.indexOf("ALL")!=-1)
          this.filterArr.map(filterObj=>filterObj['disableFlag']=true);
        else {
          let defaultSelectionFlag = true;
          this.filterArr.map(filterObj=> {
            filterObj['disableFlag'] = (this.disableArr.indexOf(filterObj['name'])!=-1) ? true : false;
            filterObj['flag'] = false;
            if(defaultSelectionFlag && this.disableArr.indexOf(filterObj['name'])==-1 && this.msgFromFilter){
              filterObj['flag'] = true;
              defaultSelectionFlag = false;
            }
            return filterObj;
          });
        }
       
    }
    else{
      this.filterArr.map((filterObj,index)=>{
        filterObj['disableFlag']=false;
        this.disableArr = [''];
         return filterObj;
      })
     
    }
  }

  ngOnInit(): void {
  }

  onfilterClick(data, dataArr) {
    _.map(dataArr, (eachObj) => {
      if (eachObj['name'] == data['name'])
        eachObj.flag = !eachObj.flag;
      else 
        eachObj.flag = false;
    });
    this.filterSelection = _.filter(dataArr, eachObj => eachObj.flag == true)[0];
    this.onFilterChange.emit(this.filterSelection);
  }

}
